import React from 'react';
import { ChevronDown, ChevronUp, X } from 'lucide-react';

/**
 * FilterSection Component
 * Reusable collapsible section for filter panel.
 * 
 * Task: P2-001 (Updated for Equal-Priority Cascading Filters)
 */
const FilterSection = ({
  title,
  icon: Icon,
  iconColor = 'text-slate-500',
  expanded,
  onToggle,
  badge = 0,
  subtitle = '',
  onClear,
  children,
  testId
}) => {
  return (
    <div className="border-b border-slate-100">
      <button
        onClick={onToggle}
        className="w-full p-3 flex items-center justify-between hover:bg-slate-50 transition-colors"
        data-testid={testId ? `${testId}-toggle` : undefined}
      >
        <div className="flex items-center space-x-2">
          {Icon && <Icon className={`w-4 h-4 ${iconColor}`} />}
          <span className="font-medium text-sm text-slate-700">{title}</span>
          {badge > 0 && (
            <span className="px-1.5 py-0.5 bg-purple-100 text-purple-700 text-xs font-medium rounded">
              {badge}
            </span>
          )}
          {subtitle && (
            <span className="text-xs text-slate-400">{subtitle}</span>
          )}
        </div>
        <div className="flex items-center space-x-1">
          {badge > 0 && onClear && (
            <span
              role="button"
              onClick={(e) => {
                e.stopPropagation();
                onClear();
              }}
              className="p-1 text-xs text-slate-400 hover:text-red-500 hover:bg-red-50 rounded transition-colors"
              data-testid={testId ? `${testId}-clear` : undefined}
              title={`Clear ${title} filters`}
            >
              <X className="w-3.5 h-3.5" />
            </span>
          )}
          {expanded ? (
            <ChevronUp className="w-4 h-4 text-slate-400" />
          ) : (
            <ChevronDown className="w-4 h-4 text-slate-400" />
          )}
        </div>
      </button>
      
      {expanded && (
        <div className="px-3 pb-3 space-y-1">
          {children}
        </div>
      )}
    </div>
  );
};

export default FilterSection;
